export default __webpack_public_path__ + "static/media/mockUnit.e8ba6c4e.png";